export const IN = 'IN';
export const CM = 'CM';

export const MEASUREMENT_UNITS = [IN, CM];

export const LOCAL_STORAGE_KEY = 'userMeasurementUnit';
